/** Shared height and padding for Live Canvas, runs toolbar, and run list rows. */
export const RUNS_SIDEBAR_ROW_CLASS =
  "flex h-9 min-w-0 shrink-0 items-center gap-1.5 border-b border-b-slate-950/10 px-3";
